<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" *ngIf="!loading">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <span *ngIf="association.wellId > 0">Associate Well to Household</span>
      <span *ngIf="association.voucherId > 0">Associate Household to Voucher</span>
      <span *ngIf="association.householdId > 0">Associate Household to a Well</span>
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" [disabled]='loading'>Close</button>
  </div>
</div>

<mat-dialog-content>
  <!-- Household search -->
  <form #form="ngForm" [formGroup]="householdSearchForm" class="form-field-full" *ngIf="!loading && (association.wellId > 0 || association.voucherId > 0)">
    <div fxLayout="row wrap" class="matero-row">
      <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col">
        <mat-card>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Contact</mat-label>
                <input id="contactName" name="contactName" formControlName="contactName" matInput placeholder="Contact Name" />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard" style="width:100%;">
                <mat-label>Address</mat-label>
                <input id="address1" name="address1" formControlName="address1" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>City</mat-label>
                <input id="city" name="city" formControlName="city" matInput />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Zip</mat-label>
                <input id="zip" name="zip" formControlName="zip" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>County</mat-label>
                <mat-select id="county" name="county" formControlName="county">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.value}}">{{item.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>


        </mat-card>
      </div>
    </div>
    <div fxLayout="row wrap" class="matero-row">
      <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
        <mat-card>
          &nbsp;&nbsp;
          <button type="submit" id="submitButtonSearch" (click)="searchHouseholds()" mat-raised-button color="primary" title="Search" [disabled]='loading'>Search</button>
          &nbsp;&nbsp;
          <button type="submit" id="submitButtonReset" (click)="reset()" mat-raised-button color="basic" title="Clear" [disabled]='loading'>Clear</button>
        </mat-card>
      </div>
    </div>
  </form>


  <!-- Household search Results -->
  <mat-card *ngIf="!loading && (association.wellId > 0 || association.voucherId > 0)">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" class="mat-elevation-z8" style="overflow-x: auto;">

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef scope="col">&nbsp;&nbsp;&nbsp;</th>
        <td mat-cell *matCellDef="let element"> <input type="radio" id="householdId" name="householdId" value="{{element.id}}" (click)="onChangeSelectedHousehold(element.id)" /></td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Id">
          OHA <br /> Household Id
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.id}} </td>
      </ng-container>
      <ng-container matColumnDef="contactName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Contact Name">
          Contact Name
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.contactName}} </td>
      </ng-container>
      <ng-container matColumnDef="address1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Address">
          Address
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.address1}} </td>
      </ng-container>
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by city">
          City
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.city}} </td>
      </ng-container>
      <ng-container matColumnDef="zip">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by zip">
          Zip
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.zip}} </td>
      </ng-container>
      <ng-container matColumnDef="county">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by county">
          County
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.county}} </td>
      </ng-container>
      <ng-container matColumnDef="waterTreamentProvided">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Water Treatment Provided">
          Water Treatment Provided
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.waterTreamentProvided}} </td>
      </ng-container>
      <ng-container matColumnDef="bottledWaterProvided">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Bottled Water Provided">
          Bottled Water Provided
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.bottledWaterProvided}} </td>
      </ng-container>
      <ng-container matColumnDef="personsInHousehold">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Persons In Household">
          Persons In Household
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.personsInHousehold}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </mat-card>

  <!-- Well Search -->
  <form #form="ngForm" [formGroup]="wellSearchForm" class="form-field-full" *ngIf="!loading && this.association.householdId > 0">
    <div fxLayout="row wrap" class="matero-row">
      <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col">
        <mat-card>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Well Log</mat-label>
                <input id="wellId" name="wellLog" formControlName="wellLog" matInput matTooltipClass="tooltip"
                  matTooltip="This is a combination of county name and numbers; for example, a well log in Marion County could be MARI-12345" />
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Well Tag</mat-label>
                <input id="wellTag" name="wellTag" formControlName="wellTag" matInput matTooltipClass="tooltip"
                  matTooltip="Well label/tag number (L-#####). Wells built after 1996 should have a metal well tag on or near the wellhead" />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard" style="width:100%;">
                <mat-label>Address</mat-label>
                <input id="address" name="address" formControlName="address" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>City</mat-label>
                <input id="city" name="city" formControlName="city" matInput />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Zip</mat-label>
                <input id="zip" name="zip" formControlName="zip" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>County</mat-label>
                <mat-select id="county" name="county" formControlName="county">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.value}}">{{item.text}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>

      <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
        <mat-card>
          <button type="submit" id="submitButtonSearch" (click)="searchWells()" mat-raised-button color="primary" title="Search" [disabled]='loading'>Search</button>
          &nbsp;&nbsp;
          <button type="submit" id="submitButtonReset" (click)="reset()" mat-raised-button color="basic" title="Clear" [disabled]='loading'>Clear</button>
        </mat-card>
      </div>
    </div>
  </form>


  <!-- Well Search Results-->
  <mat-card *ngIf="!loading && this.association.householdId > 0">
    <table mat-table [dataSource]="dataSourceWells" matSort (matSortChange)="announceSortChange($event)" class="mat-elevation-z8" style="overflow-x: auto;">

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef scope="col">&nbsp;&nbsp;&nbsp;</th>
        <td mat-cell *matCellDef="let element"> <input type="radio" id="wellId" name="wellId" value="{{element.wellId}}" (click)="onChangeSelectedWell(element.wellId)" /></td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Id">
          OHA Well Id
        </th>
        <td mat-cell *matCellDef="let result"> &nbsp;&nbsp;{{result.wellId}} </td>
      </ng-container>
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Address">
          Address
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.wellAddress1}} </td>
      </ng-container>
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by city">
          City
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.wellCity}} </td>
      </ng-container>
      <ng-container matColumnDef="zip">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by zip">
          Zip
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.wellZip}} </td>
      </ng-container>
      <ng-container matColumnDef="county">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by county">
          County
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.wellCounty}} </td>
      </ng-container>
      <ng-container matColumnDef="wellTag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Well Tag">
          Well Tag
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.wellTag}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsWells"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsWells;"></tr>
    </table>
  </mat-card>


  <!-- Association form -->
  <div fxLayout="row wrap" class="matero-row" *ngIf="!loading">
    <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonSearch" (click)="associateWell()" mat-raised-button color="primary" *ngIf="this.association.wellId > 0" title="Associate Household to Well"
          [disabled]='loading || selectedHouseholdId == 0'>Associate Household to Well</button>


        <button type="submit" id="submitButtonSearch" (click)="associateVoucher()" mat-raised-button color="primary" *ngIf="this.association.voucherId > 0" title="Associate Household to Voucher"
          [disabled]='loading || selectedHouseholdId == 0'>Associate Household to Voucher</button>

        <button type="submit" id="submitButtonSearch" (click)="associateWell()" mat-raised-button color="primary" *ngIf="this.association.householdId > 0" title="Search"
          [disabled]='loading || selectedWellId == 0'>Associate Well to Household</button>
      </mat-card>
    </div>
  </div>

</mat-dialog-content>